import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { stringify } from "query-string";
import withViewport from "../../Viewport/withViewport";
import withTranslation from "../../translation";
import styles from "./index.css";
import { getMyAccountBaseUrl } from "../../../helpers/externalLinks";
import classnames from "classnames";
import { tabIndex } from "../../../../helpers/accessibility";

const MY_ACCOUNT = "MyAccount";
const MY_ORDERS = "MyOrders";
const RETURNS_INFORMATION = "ReturnsInformation";
const ALIST = "AList";
const GB = "GB";
const cx = classnames.bind(styles);

class MyAccountLinks extends PureComponent {
  static propTypes = {
    formatTranslation: PropTypes.func.isRequired,
    isVisible: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    storeCode: PropTypes.string.isRequired,
    keyStoreDataversion: PropTypes.string.isRequired,
    defaultStoreUrl: PropTypes.string.isRequired,
    focusable: PropTypes.bool,
    queryParams: PropTypes.object
  };

  buildLinks() {
    const {
      formatTranslation,
      countryCode,
      lang,
      storeCode,
      keyStoreDataversion,
      defaultStoreUrl,
      queryParams = {}
    } = this.props;

    const queryString =
      "?" +
      stringify({
        ...queryParams,
        lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion
      });

    const baseUrl = getMyAccountBaseUrl();

    const links = [
      {
        id: MY_ACCOUNT,
        href: baseUrl + queryString
      },
      {
        id: MY_ORDERS,
        href: `${baseUrl}/orders${queryString}`
      },
      {
        id: RETURNS_INFORMATION,
        href:
          defaultStoreUrl.concat(
            formatTranslation(`MyAccountLinks.${RETURNS_INFORMATION}Link`)
          ) + queryString
      }
    ];

    if (countryCode === GB) {
      links.push({
        id: ALIST,
        href: `${baseUrl}/a-list${queryString}`
      });
    }

    return links;
  }

  render() {
    const { isVisible, formatTranslation, focusable } = this.props;

    if (!isVisible) return null;

    return (
      <div>
        {this.buildLinks().map(({ id, href }) => (
          <a
            href={href}
            className={cx(styles.link, styles[id])}
            key={id}
            tabIndex={tabIndex(focusable)}
          >
            {formatTranslation(`MyAccountLinks.${id}`)}
          </a>
        ))}
      </div>
    );
  }
}

export default withViewport(withTranslation(MyAccountLinks));



// WEBPACK FOOTER //
// ./template/components/Footer/MyAccountLinks/MyAccountLinks.js